class constants {
    static contentTypes = {
        equipmentStash: 'equipment-stash',
        merchant: 'merchant',
        creature: 'creature',
        character: 'character',
    }
}

export default constants
